<template>
  <div class="flex flex-row items-center gap-2 md:gap-3 justify-between">
    <div
      class="cursor-pointer flex flex-row items-center px-1 md:px-0 gap-2"
      @click="handleCollapse"
    >
      <Icon
        name="chevron-down"
        class="fg-quaternary transition-transform duration-200"
        :class="{ 'rotate-180': isCollapsed }"
      />
      <div class="text-primary text-style-xl md:text-style-sm font-semibold">
        {{ $t("components.task_details.checklist.title") }}
      </div>
      <ChecklistBadge :total="itemsCount" :checked="checkedItemsCount" />
    </div>
    <Add
      v-if="canUpdateChecklist && !isTaskCompleted"
      :itemsCount="itemsCount"
      @add:items="handleAddItems"
    >
      <Button
        :label="$t('components.buttons.add_checklist_item')"
        variant="tertiary"
        type="color"
        :size="maxTablet ? 'lg' : 'xs'"
        :disabled="busy"
      >
        <template #start>
          <Icon name="plus" />
        </template>
      </Button>
    </Add>
  </div>
</template>

<script setup>
import { Icon } from "@/SharedComponents/Icon";
import { Button } from "@/SharedComponents/Buttons";
import { ChecklistBadge } from "@/SharedComponents/Badges";
import { Add } from "@/SharedComponents/Checklist/Modals";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxTablet } = useBreakpoints();

defineProps({
  isCollapsed: { type: Boolean, required: true },
  itemsCount: { type: Number, required: true },
  checkedItemsCount: { type: Number, required: true },
  canUpdateChecklist: { type: Boolean, required: true },
  isTaskCompleted: { type: Boolean, required: true },
  busy: { type: Boolean, required: true },
});

const emit = defineEmits(["collapse", "add:items"]);

function handleCollapse() {
  emit("collapse");
}

function handleAddItems(items) {
  emit("add:items", items);
}
</script>
